export default __webpack_public_path__ + "static/media/security_ddos.a5961aca.svg";